import React, {Component} from 'react';
import {translate} from 'react-i18next';
import PageHeader from "../elements/PageHeader";
import * as moment from 'moment';
import 'moment/locale/de';
import config from '../../config/config.js';
import axios from 'axios';
import {NotificationManager} from 'react-notifications';

class ApplicationScreen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            noApplicationFound: false,
            application: null
        };

        this.getNextApplication = this.getNextApplication.bind(this);
        this.handleGetNext = this.handleGetNext.bind(this);
    }

    componentDidMount() {
        this.getNextApplication(this.props.match.params.supporterProjectId ? this.props.match.params.supporterProjectId : '0');
        this.interval = setInterval(() => {
            if (this.state.application && this.state.application.open && !this.state.application.locked) {
                axios(config.server.endpoint + 'backend/application/lock/' + this.state.application.supporterProjectId, {
                    method: 'put'
                }).then((response) => {
                    if (response.status === 200) {
                        if (response.data.success !== true) {
                            NotificationManager.warning("Warnung", "Die Bewerbung konnte nicht für andere User gesperrt werden.", 3000);
                            /*this.setState({
                                loading: false,
                                noApplicationFound: false,
                                application: null,
                                stats: null
                            });*/

                        }
                    }
                });
            }
        }, 10000)
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    handleGetNext() {
        this.getNextApplication();
    }

    getNextApplication(supporterProjectId) {
        this.setState({
            loading: true
        });
        let lastId = 0;
        if (this.state.application && this.state.application.supporterProjectId) {
            lastId = this.state.application.supporterProjectId;
        }
        axios(config.server.endpoint + 'backend/application/get/' + lastId + '/' + supporterProjectId, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    this.setState({
                        loading: false,
                        noApplicationFound: false,
                        application: response.data.application,
                        stats: response.data.stats
                    });
                } else {
                    if (response.data.error && response.data.error === 'noApplicationFound') {
                        this.setState({
                            loading: false,
                            noApplicationFound: true,
                            application: null
                        });
                    } else {
                        this.setState({
                            loading: false,
                            noApplicationFound: false,
                            application: null
                        });
                    }
                }
            }
        });
    }

    accept(acceptApplication) {
        const {t} = this.props;
        this.setState({
            loading: true
        });
        axios(config.server.endpoint + 'backend/application/decide/' + this.state.application.supporterProjectId + '/' + acceptApplication, {
            method: 'put'
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    this.getNextApplication();
                    this.setState({
                        noApplicationFound: false,
                        application: null
                    });
                    NotificationManager.success(t('applicationScreen.accept.success.' + acceptApplication + '.text'), t('applicationScreen.accept.success.' + acceptApplication + '.title'), 6000);
                } else {
                    this.setState({
                        loading: false,
                        noApplicationFound: false,
                        application: null
                    });
                }
            }
        });
    }

    render() {
        const {t} = this.props;
        return (
            <div className="ApplicationScreen">
                <PageHeader title={t('applicationScreen.title')} subtitle={t('applicationScreen.subtitle')}/>
                {this.state.stats ? (
                    <div className="row m-t">
                        <div className="col-xs-12">
                            <div className="ibox">
                                <div className="ibox-title">
                                    <h4>
                                        {t('applicationScreen.stats.title')}
                                    </h4>
                                </div>
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-xs-2">
                                            <h4>
                                                {this.state.stats.applications}
                                            </h4>
                                            <strong>
                                                {t('applicationScreen.stats.applications.title')}
                                            </strong>
                                            <p>
                                                <small>
                                                    {t('applicationScreen.stats.applications.text')}
                                                </small>
                                            </p>
                                        </div>
                                        <div className="col-xs-2">
                                            <h4>
                                                {this.state.stats.accepted}
                                            </h4>
                                            <strong>
                                                {t('applicationScreen.stats.accepted.title')}
                                            </strong>
                                            <p>
                                                <small>
                                                    {t('applicationScreen.stats.accepted.text')}
                                                </small>
                                            </p>
                                        </div>
                                        <div className="col-xs-2">
                                            <h4>
                                                {this.state.stats.not_accepted}
                                            </h4>
                                            <strong>
                                                {t('applicationScreen.stats.not_accepted.title')}
                                            </strong>
                                            <p>
                                                <small>
                                                    {t('applicationScreen.stats.not_accepted.text')}
                                                </small>
                                            </p>
                                        </div>
                                        <div className="col-xs-2">
                                            <h4>
                                                {this.state.stats.denied}
                                            </h4>
                                            <strong>
                                                {t('applicationScreen.stats.denied.title')}
                                            </strong>
                                            <p>
                                                <small>
                                                    {t('applicationScreen.stats.denied.text')}
                                                </small>
                                            </p>
                                        </div>
                                        <div className="col-xs-2">
                                            <h4>
                                                {this.state.stats.may_reactivate}
                                            </h4>
                                            <strong>
                                                {t('applicationScreen.stats.may_reactivate.title')}
                                            </strong>
                                            <p>
                                                <small>
                                                    {t('applicationScreen.stats.may_reactivate.text')}
                                                </small>
                                            </p>
                                        </div>
                                        <div className="col-xs-2">
                                            <h4>
                                                {this.state.stats.may_registrate}
                                            </h4>
                                            <strong>
                                                {t('applicationScreen.stats.may_registrate.title')}
                                            </strong>
                                            <p>
                                                <small>
                                                    {t('applicationScreen.stats.may_registrate.text')}
                                                </small>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                <div className="row m-t">
                    <div className="col-xs-12 text-right">
                        <button className="btn btn-default" onClick={this.handleGetNext}>
                            <i className="fa fa-arrow-right m-r-xs"/>
                            {t('applicationScreen.getNextApplication')}
                        </button>
                    </div>
                </div>
                {this.state.loading ? (
                    <div className="row">
                        <div className="col-xs-12 m-t text-center">
                            <i className="fa fa-spin fa-5x fa-spinner"/>
                        </div>
                    </div>
                ) : (this.state.application ? (
                    <div className="row m-t">
                        <div className="col-xs-12">
                            <div className="ibox">
                                <div className="ibox-title">
                                    <h4>
                                        {t('applicationScreen.application.from')}: {this.state.application.firstname} {this.state.application.lastname}
                                    </h4>
                                </div>
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="col-xs-6 no-margins no-padding">
                                                <p>
                                                    <strong>
                                                        {t('applicationScreen.application.firstFusionYear')}
                                                    </strong><br/>
                                                    {this.state.application.firstFusionYear}
                                                </p>
                                            </div>
                                            <div className="col-xs-6 no-margins no-padding">
                                                <p>
                                                    <strong>
                                                        {t('applicationScreen.application.previousWorkType')}
                                                    </strong><br/>
                                                    {this.state.application.previousWorkType ? this.state.application.previousWorkType.name : ''}
                                                </p>
                                            </div>
                                            <p>
                                                <strong>
                                                    {t('applicationScreen.application.application')}
                                                </strong><br/>
                                                {this.state.application.application}
                                            </p>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="col-xs-6 no-margins no-padding">
                                                <p>
                                                    <strong>
                                                        {t('applicationScreen.application.firstname')}
                                                    </strong><br/>
                                                    {this.state.application.firstname}
                                                </p>
                                            </div>
                                            <div className="col-xs-6 no-margins no-padding">
                                                <p>
                                                    <strong>
                                                        {t('applicationScreen.application.lastname')}
                                                    </strong><br/>
                                                    {this.state.application.lastname}
                                                </p>
                                            </div>
                                            <div className="col-xs-6 no-margins no-padding">
                                                <p>
                                                    <strong>
                                                        {t('applicationScreen.application.birthday')}
                                                    </strong><br/>
                                                    {moment(this.state.application.birthday).format('DD.MM.YYYY')}
                                                </p>
                                            </div>
                                            <div className="col-xs-6 no-margins no-padding">
                                                <p>
                                                    <strong>
                                                        {t('applicationScreen.application.zipcodeCity')}
                                                    </strong><br/>
                                                    {this.state.application.zipcode} {this.state.application.city}
                                                </p>
                                            </div>
                                            <div className="col-xs-6 no-margins no-padding">
                                                <p>
                                                    <strong>
                                                        {t('applicationScreen.application.email')}
                                                    </strong><br/>
                                                    {this.state.application.email}
                                                </p>
                                            </div>
                                            <div className="col-xs-6 no-margins no-padding">
                                                <p>
                                                    <strong>
                                                        {t('applicationScreen.application.phone')}
                                                    </strong><br/>
                                                    {this.state.application.phone}
                                                </p>
                                            </div>
                                            <div className="col-xs-6 no-margins no-padding">
                                                <p>
                                                    <strong>
                                                        {t('applicationScreen.application.handycap')}
                                                    </strong><br/>
                                                    {this.state.application.handycap}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="hr-line-dashed"/>

                                    <div className="row">
                                        <div className="col-xs-12 text-right">
                                            {this.state.application.locked ? (
                                                <div className="font-bold">
                                                    {t('applicationScreen.application.locked')}
                                                    <button className="btn btn-default m-l"
                                                            onClick={() => this.getNextApplication(this.state.application.supporterProjectId)}>
                                                        <i className="fa fa-refresh"/>
                                                    </button>
                                                </div>
                                            ) : !this.state.application.open ? (
                                                <div className="font-bold">
                                                    {t('applicationScreen.application.notOpen')}
                                                </div>
                                            ) : (
                                                <div className="btn-group">
                                                    <button className="btn btn-warning"
                                                            onClick={() => this.accept('false')}>
                                                        <i className="fa fa-close m-r-xs"/>
                                                        {t('applicationScreen.accept.false')}
                                                    </button>
                                                    <button className="btn btn-success"
                                                            onClick={() => this.accept('true')}>
                                                        <i className="fa fa-check m-r-xs"/>
                                                        {t('applicationScreen.accept.true')}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (this.state.noApplicationFound ? (
                    <div className="alert alert-warning">
                        {t('applicationScreen.error.noApplicationFound')}
                    </div>
                ) : (
                    <div className="alert alert-danger">
                        {t('applicationScreen.error.unknown')}
                    </div>
                )))}


            </div>
        )
    }
}

export default translate()(ApplicationScreen);